import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../../../genericComponents/forms/GenericFormHeaderComponent'
import ListComponent from '../../../../genericComponents/ListComponent'
import GenericCustomButton from '../../../../genericComponents/GenericCustomButton'
import Icons from '../../../../assets/icons'
import { dispatchHandler } from '../../../../helper/apiHelperFunctions'
import { useDispatch, useSelector } from 'react-redux'
import ParentModal from '../../../../genericComponents/ParentModal'
import AddNewAddress from './AddNewAddress'
import { Trash2 } from 'lucide-react'

const ManageAddress = (props) => {
    // Modal to add , delete and edit addresses.

    const dispatch = useDispatch();

    const [refreshTable, setRefreshTable] = useState(false);
    const [selectedModal, setSelectedModal] = useState(false);
    const [selectedData, setSelectedData] = useState({});

    const deleteAddressLineItemData = useSelector(state => state?.digivendStore?.deleteAddressLineItemData);
    const getTableComponentFourthListData = useSelector(state => state?.generalStore?.getTableComponentFourthListData)

    const updateAddressData = useSelector(state => state?.digivendStore?.updateAddressData);

    useEffect(()=>{
        if(updateAddressData?.isSuccess){
            setSelectedModal(false);
            setRefreshTable(true);
        }
    },[updateAddressData?.isSuccess])

    useEffect(()=>{
        if(getTableComponentFourthListData?.isLoading){
            setRefreshTable(false)
        }
    },[getTableComponentFourthListData?.isLoading])

    useEffect(()=>{
        if(deleteAddressLineItemData?.isSuccess){
            setRefreshTable(true);
        }
    },[deleteAddressLineItemData?.isSuccess])

    // Function : To render the header component of the Manage Address
    const renderHeaderComponent = () => {
        return <GenericFormHeaderComponent
            label = {{
                contentPrimary : "Manage Addresses",
                contentSecondry : "You can create new and manage existing addresses here",
            }}
            rightComponent = {() => (
                <GenericCustomButton
                    type='primary'
                    label = "Add New Address"
                    onClick={() => handleChange("addNewAddress")}
                />
            )}
            closeModal = {props.closeModal}
        />
    }
    

    const handleChange = (key, data = {}) => {
        switch(key){
            default : {
                setSelectedModal(key)
                setSelectedData(data);
                break;
            }
        }
    }

    const getParentChildProps = () =>{
        switch(selectedModal){
            case "addNewAddress":{
                return {
                    animationType: "bottom",
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: 5 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
					postitionProps: { position: 'relative' },
                    dimensions: { width: "50%", height: "60%", maxHeight: '510px', maxWidth: '730px', borderRadius: 5 },
                    closeModal : () => setSelectedModal(false),
                    selectedData : selectedData,
                    permissionObj : props.permissionObj
                }
            }
        }
    }
    const getChildComponent = () => {
        switch(selectedModal){
            case "addNewAddress": return AddNewAddress;
        }
    }

    // Function  : To render the list component
    const renderListData = () => {
        return(
            <ListComponent
                useKeyboardShortcuts = {false}
                viewDataType= "table-view"
                search = {{
                    placeholder : "Type to Search",
                    isSearchIconRequire : true,
                }}
                headerKeys = {{
                    "editDelete" : {value : "",},
                    "shortName" : {value : "Short Name"},
                    "email"  :{value : "Email"},
                    "address" : {value : "Address Line1"},
                    "addressLine1" : {value : "Address Line2"},
                    "country" : {value : "Country"},
                    "state" : {value : "State"},
                    "city" : {value : "City"},
                    "zipCode" : {value : "Zipcode"},
                    "contactPerson" : {value : "Contact Person"},
                    "contactNumber" : {value : "Contact Number"},
                }}
                itemKeys = {{
                    "editDelete" : [(states, functions, item) => <div className='mdlrc-btns'>
                        <GenericCustomButton
                          tooltip = "Edit"
                          leftIcon={<Icons.EditNewIcon/>}
                          onClick={() => handleChange("addNewAddress", item)}
                      />
                      <GenericCustomButton
                          tooltip = "Delete"
                          leftIcon={<Trash2 size={15} strokeWidth={1.75} />}
                          onClick={() => dispatchHandler(dispatch, "deleteAddressLineItemRequest", {
                              id : item?.id || ""
                          }, props.permissionObj) }
                      />
                  </div>],
                    "shortName" :["shortName"],
                    "email"  : ["email"],
                    "address" : ["address"],
                    "addressLine1" : ["addressLine1"],
                    "country" : ["country"],
                    "state" : ["state"],
                    "city" : ["city"],
                    "zipCode" : ["zipCode"],
                    "contactPerson" : ["contactPerson"],
                    "contactNumber" : ["contactNumber"],
                }}
                getListData = {(data) => data?.resource?.data || []}
                api = {{
                    reduxState: "generalStore",
                    apiName: "getTableComponentFourthList",
                    apiExtraHeaders: props.permissionObj,
                    apiPayload: (params) => {
                        return {
                            "pageNo": params?.currentPage || 1,
                            "type":  params?.currentSearch  ? 3: 1,
                            "search": params?.currentSearch || "",
                            "filter": {},
                            "sortedBy": "",
                            "sortedIn": "",
                            "apiUrl" : "/address/master/getAll"
                        }
                    },
                    getMaxPage: (states, functions, response) => {
                        return 1;
                    }
                }}
                refreshData = {refreshTable}
            />
        )
    }

    return (
        <div className='manage-address-modal'>
            {renderHeaderComponent()}

            {/* Render the list of the data of addresses */}
            {renderListData()}

            {selectedModal && <ParentModal
                getParentChildProps={getParentChildProps()}
				childComponent={getChildComponent()}
            />}
        </div>
    )
}

export default ManageAddress